import { CanvasesRefType, CanvasRefPairType } from "../types";

/**
 * Load an image into the appropriate canvas (front or back).
 * The image is drawn with the aspect ratio preserved, and any extra space is filled with white.
 */
const paintCanvasImage = async (cardKey: number, face: "front" | "back", canvases: CanvasRefPairType) => {
    const canvasRef = face === "front" ? canvases.front : canvases.back;
    const canvas = canvasRef.current;

    if (!canvas) {
      console.error("Canvas not found for face:", face);
      return;
    }
  
    const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
    const imageUrl = `${baseUrl}/images/thumbnails/card${cardKey}${face}.jpg`;
  
    try {
      const img = new Image();
      img.crossOrigin = "anonymous"; // Allow cross-origin image loading
  
      img.onload = () => {
        const ctx = canvas.getContext("2d");
  
        if (!ctx) {
          console.error("Failed to get canvas context");
          return;
        }
  
        // Determine image orientation
        const isHorizontal = img.width > img.height;
        const canvasWidth = isHorizontal ? 853 : 512;
        const canvasHeight = isHorizontal ? 512 : 853;
  
        // Set canvas size
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
  
        // Clear canvas and fill with white background
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  
        // Calculate aspect-ratio-preserving dimensions
        const imgAspectRatio = img.width / img.height;
        const canvasAspectRatio = canvasWidth / canvasHeight;
  
        let drawWidth, drawHeight;
        if (imgAspectRatio > canvasAspectRatio) {
          // Image is wider than canvas
          drawWidth = canvasWidth;
          drawHeight = canvasWidth / imgAspectRatio;
        } else {
          // Image is taller than canvas
          drawWidth = canvasHeight * imgAspectRatio;
          drawHeight = canvasHeight;
        }
  
        // Center the image on the canvas
        const drawX = (canvasWidth - drawWidth) / 2;
        const drawY = (canvasHeight - drawHeight) / 2;
  
        ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight);
  
        // Mark canvas as contentful
        canvas.setAttribute("contentful", "true");
      };
  
      img.onerror = () => {
        console.error("Failed to load image:", imageUrl);
      };
  
      img.src = imageUrl;
    } catch (error) {
      console.error("Error loading canvas:", error);
    }
};
  
export default paintCanvasImage;